import React from "react"

const Logo = () => {
  return (
    <div classNameName="logo nemo--aniamtion">
      <svg height="60" id="Layer_1" xmlns="http://www.w3.org/2000/svg" viewBox="-395 273.3 50 50">
  <path id="fire" className="st0" d="M-380.6 308.8c2.2 2.1 2.2 5.7 0 7.8-2.2 2.1-8.9 4.9-11.1 2.8s.7-8.5 2.9-10.6c2.3-2.1 5.9-2.1 8.2 0z"/>
  <path className="st0" d="M-380.9 309c-.1.2-.1.3-.3.5-1.4 1.3-2.8 2.7-4.2 4-1 1-2 1.9-3 2.9-.8.7-1.5 1.4-2.3 2.1-.2.2-.5.2-.7 0-.2-.2-.2-.5.1-.7 2.1-2 4.2-4 6.3-6.1 1.1-1 2.1-2 3.2-3 .1-.1.4-.1.5-.1.2.1.3.3.4.4zm1.6 1.9c.2.1.4.2.5.3.2.2.1.5-.1.6-.6.5-1.1 1.1-1.7 1.6-1.7 1.6-3.4 3.3-5.1 4.9-.3.3-.5.3-.7.1-.2-.2-.2-.5.1-.8 1.1-1 2.2-2.1 3.3-3.1 1.2-1.1 2.3-2.2 3.5-3.3-.2-.1 0-.2.2-.3zm-4.3-4.6c.1.1.3.1.4.3.2.2.1.4-.1.6l-1 1c-1.8 1.7-3.5 3.4-5.3 5-.2.2-.5.4-.7.6-.3.2-.5.2-.7 0-.2-.2-.2-.5.1-.7.6-.6 1.2-1.1 1.8-1.7 1.1-1 2.1-2 3.2-3 .6-.6 1.3-1.2 1.9-1.8.1-.1.2-.2.4-.3z" id="Lines"/>
  <g id="rocket">
    <path id="Path_1_" className="st1" d="M-367.7 296c6.7 6.7 8 16.2 1.7 22.5l-3 3c-6.3 6.3-2-8.9-8.6-15.5s-21.9-2.3-15.5-8.6l3-3c6.3-6.4 15.7-5.1 22.4 1.6z"/>
    <path id="Path_2_" className="st1" d="M-346 274.3c1 .9 1.3 4.3 0 8.8-1.4 5.1-4.7 11.6-11.3 18-8.1 7.9-13.2 10.7-13.2 10.7-5.4 3.6-8 1.1-11.4-2.2-3.4-3.4-6-5.9-2.3-11.3 0 0 2.9-5.1 10.9-13 6.2-6.1 12.5-9.4 17.5-10.9 5-1.4 8.7-1.1 9.8-.1z"/>
    <path id="Path_3_" className="st2" d="M-359 286.7c1.9 1.9 1.9 5.1 0 7-1.9 1.9-5.1 1.9-7 0-1.9-1.9-1.9-5.1 0-7 1.9-1.9 5.1-1.9 7 0z"/>
    <path id="Path_4_" className="st2" d="M-371.1 298.5c1 .9-.9 4.3-5.7 8.8-4.8 4.6-7.7 5.8-8.6 4.8-1-.9.3-3.7 5-8.3 4.8-4.4 8.3-6.2 9.3-5.3z"/>
  </g>
</svg>
    </div>
  )
}

export default Logo
